import React, { Fragment } from "react";
import { Form } from "react-bootstrap";
import $ from "jquery";
const TextareaForm = (props) => {
    const { value, onChangeValue, labelTxt, name, req, placeholderTxt, minHeight, id, rows } = props;
    return (
        <Fragment>
            <Form.Group>
                <Form.Label>
                    {labelTxt} {req && <span className="required">*</span>}
                </Form.Label>
                <Form.Control
                    id={id}
                    as="textarea"
                    rows={rows ? rows : 3}
                    placeholder={placeholderTxt}
                    name={name}
                    value={value}
                    onChange={(e) => {
                        $(`#${id}`).removeClass("danger");
                        onChangeValue(e);
                    }}
                    className={req ? "req" : ""}
                    style={{ minHeight: minHeight ? minHeight : "auto" }}
                />
            </Form.Group>
        </Fragment>
    );
};

export default TextareaForm;
